<ng-container *ngIf="loading$ | async">
    <app-loader></app-loader>
</ng-container>

<ng-container *ngIf="!(loading$ | async)">
    <div class="content">
        <mat-drawer-container [ngClass]="'mat-drawer-container-wrapper'">
            <app-display-consent-header
                    [comments]="comments$ | async"
                    [ttsIconState]="ttsIconState"
                    [activeOutlineTab]="activeOutlineTab"
                    [repeatButtonDisabled]="repeatButtonDisabled"
                    [indicationTitle]="indicationTitle"
                    [informationUnitTitle]="informationUnitTitle"
                    [stopAudio]="pauseAudioSubject.asObservable()"
                    [submittedConsentId]="this.submittedConsentId"
                    [language]="wizardContent?.language"
                    [languageStyle]="wizardContent?.languageStyle"
                    [presentationMode]="wizardContent?.presentationMode"
                    [selectedIndication]="wizardContent?.selectedIndication"
                    [selectedUseCase]="wizardContent?.selectedUseCase"
                    [chapterUseCases]="chapterUnits"
                    [showHeaderControls]="true"
                    [showBackButton]="true"
                    [backButtonText]="backButtonText"
                    [enableCommenting]="loggedUserSettings?.commentingSingleTypeOff"
                    [enableSettings]="true"
                    (playFromStartAudioEvent)="play()"
                    (pauseAudioEvent)="pause(false)"
                    (readTextEvent)="readText()"
                    (leaveIndication)="onLeaveIndication()"
                    (openDialog)="openPopUpDialog($event)"
                    (backEvent)="previousStep()"
                    (toggleMenu)="toggleMenu(drawer, $event)">
            </app-display-consent-header>
            <mat-drawer #drawer mode="side">
                <app-display-consent-menu
                        [sideMenuOpen]="sideMenuOpen"
                        [treeData]="treeData$ | async"
                        [currentUnitOrderId]="currentUnitOrderId"
                        [openMenu]="openMenu"
                        [consentId]="submittedConsentId"
                        [comments]="comments$ | async"
                        [textSize]="textSize"
                        [hideCloseIcon]="hideCloseIcon"
                        [enableCommenting]="loggedUserSettings?.commentingSingleTypeOff"
                        (closeEvent)="closeMenu(drawer)"
                        (addCommentEvent)="submitComment($event)"
                        (deleteCommentEvent)="deleteComment($event)"
                        (editCommentEvent)="editComment($event)"
                        (slideChangeEvent)="changeTextSize($event)"
                        (displayUnderstoodUnitAgainEvent)="previewChosenUnit($event)"
                        (pauseAudioEvent)="pause(false)">
                </app-display-consent-menu>
            </mat-drawer>
            <div class="content__text">
                <app-display-consent-text
                        [textToDisplay]="unitText"
                        [textSize]="textSize"
                        [initialLanguageStyle]="selectedLanguageStyle"
                        [commentHereButtonDisabled]="commentHereButtonDisabled"
                        [enableCommenting]="loggedUserSettings?.commentingSingleTypeOff"
                        [enableEasyLanguageStyle]="!loggedUserSettings?.lightLanguageStyleOff"
                        [indicationId]="unitToDisplay?.indicationId"
                        (openDialog)="openPopUpDialog($event)"
                        (selectedTab)="temporaryLanguageStyleChange($event)"
                        (openMenu)="openCommentMenu(drawer)">
                </app-display-consent-text>
            </div>
            <div class="content__footer">
                <app-display-consent-footer
                        [disableSkip]="skipToUnits"
                        [disableNext]="showFinishBtn"
                        [moreButton]="moreButtonDisabled"
                        [moveToText]="moveToText"
                        [isAudioMode]="autoPlayVoice"
                        (emitButtonClick)="onButtonClick($event)">
                </app-display-consent-footer>
            </div>
        </mat-drawer-container>
        <app-notification></app-notification>
    </div>
</ng-container>

